<template>
  <v-app id="avaliacao-treinamento" class="app-tabela">
    <div class="boxcardtabela" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title class="d-flex flex-column flex-md-row align-items-start">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            class="input-bottom flex-grow-1 mb-2 mb-md-0"
            single-line
            hide-details
          ></v-text-field>
          <!-- <vue-select
            v-model="selectedUbs"
            :options="ubsOptions"
            label="no_unidade_saude"
            placeholder="Selecionar UBS"
            class="vue-select flex-grow-1 ml-md-2"
            @input="filterByUbs"
          >
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select> -->
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="filteredItems"
          :search="search"
          item-key="index"
          :loading="loading"
          loading-text="Carregando, por favor espere"
          class="elevation-1"
          :items-per-page="itemsPerPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [],
            'disable-items-per-page': true,
          }"
          @pagination="getPagination"
        >
          <template v-slot:[`item.descricao`]="{ item }">
            <span>{{ getDescricao(item) }}</span>
          </template>
          <template v-slot:[`item.dt_treinamento`]="{ item }">
            <span>{{ formatDate(item.dt_treinamento) }}</span>
          </template>
          <template v-slot:[`item.dt_avaliacao`]="{ item }">
            <span>{{ formatDate(item.dt_avaliacao) }}</span>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteEsusPecGlobal />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} avaliações</span
            >
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import vueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import FonteEsusPecGlobal from '@/components/FonteEsusPecGlobal'
import utils from '@/mixins/utils.js'

export default {
  name: 'TabelaAvaliacaoTreinamento',
  components: {
    'vue-select': vueSelect,
    FonteEsusPecGlobal: FonteEsusPecGlobal,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tipoAnalise: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [utils],
  data() {
    return {
      search: '',
      selectedUbs: null,
      currentPage: 1,
      itemsPerPage: 10,
      headers: [
        { text: 'Função', value: 'funcao' },
        { text: this.descricaoTitulo, value: 'descricao' },
        { text: 'Data Atividade', value: 'dt_treinamento' },
        { text: 'Data Avaliação', value: 'dt_avaliacao' },
      ],
    }
  },
  computed: {
    filteredItems() {
      if (this.selectedUbs) {
        return this.indexedItems.filter(
          (item) => item.cnes === this.selectedUbs.nu_cnes
        )
      }
      return this.indexedItems
    },
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        index: index,
        ...item,
      }))
    },
    descricaoTitulo() {
      if (this.tipoAnalise && this.tipoAnalise.label === 'SUS Digital') {
        return 'Opinião sobre o SUS Digital'
      } else if (
        this.tipoAnalise &&
        this.tipoAnalise.label === 'AVALIAÇÃO DOS PARTICIPANTES'
      ) {
        return 'Avaliação dos Participantes'
      } else if (
        this.tipoAnalise &&
        this.tipoAnalise.label === 'TEMAS SUGERIDOS'
      ) {
        return 'Temas Sugeridos'
      }
      return 'Descrição'
    },
    ubsOptions() {
      return this.$parent.$data.equipes
    },
  },
  methods: {
    getDescricao(item) {
      if (this.tipoAnalise && this.tipoAnalise.label === 'SUS Digital') {
        return item.descricao_compreensao_usuario
      } else if (
        this.tipoAnalise &&
        this.tipoAnalise.label === 'AVALIAÇÃO DOS PARTICIPANTES'
      ) {
        return item.opiniaoTreinamento
      } else if (
        this.tipoAnalise &&
        this.tipoAnalise.label === 'TEMAS SUGERIDOS'
      ) {
        return item.sugestao_tema
      }
      return ''
    },
    filterByUbs() {
      this.$emit('filterByUbs', this.selectedUbs)
    },
    calculateTotalSum() {
      return this.filteredItems.length
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} pagination Dados da paginação
     */
    getPagination(pagination) {
      this.currentPage = pagination.page
      this.itemsPerPage = pagination.itemsPerPage
    },
  },
  watch: {
    tipoAnalise: {
      handler() {
        this.headers = [
          { text: 'Função', value: 'funcao' },
          { text: this.descricaoTitulo, value: 'descricao' },
          { text: 'Data Atividade', value: 'dt_treinamento' },
          { text: 'Data Avaliação', value: 'dt_avaliacao' },
        ]
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style scoped>
#avaliacao-treinamento .app-tabela {
  width: 100%;
}

#avaliacao-treinamento .input-bottom {
  margin-bottom: 0;
}

#avaliacao-treinamento .vue-select {
  font-size: 14px;
  font-weight: normal;
  padding-top: 14px;
}

.boxcardtabela {
  position: relative;
  margin-bottom: 0px;
  width: 100%;
  background: #fff;
  padding: 0px;
  border-radius: 5px;
  transition: 0.5s;
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 0 5px 1px 0 rgb(103 151 255 / 11%),
    0 12px 90px 0 rgb(103 151 255 / 11%);
  margin-top: 20px;
}

@media (min-width: 768px) {
  #avaliacao-treinamento .v-card-title {
    flex-direction: row !important;
  }
}

@media (max-width: 767px) {
  #avaliacao-treinamento .v-card-title {
    flex-direction: column !important;
  }

  #avaliacao-treinamento .input-bottom,
  #avaliacao-treinamento .vue-select {
    width: 100% !important;
    margin-left: 0 !important;
  }
}

@media (min-width: 768px) and (max-width: 960px) {
  #avaliacao-treinamento .v-card-title {
    flex-direction: column !important;
  }

  #avaliacao-treinamento .input-bottom,
  #avaliacao-treinamento .vue-select {
    width: 100% !important;
    margin-left: 0 !important;
  }
}
</style>
